import { ApiClient } from '@make-software/tg-mini-app-ui';

import { WITH_AUTH } from '@/shared';
import { GetLeaderboardResponseType } from '@/entities';

export const getLeaderboardData = async (offset: number = 0, limit: number = 30) => {
  const { data, error, loading, httpCode } = await ApiClient.get<GetLeaderboardResponseType>(
    `${window.config.api_endpoint}/users/me/leaderboard?offset=${offset}&limit=${limit}`,
    WITH_AUTH
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};
